import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { pickBy } from 'lodash';

import { ProjectMetaData } from '@app/@core/models/project-meta-data';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class ProjectsService {
  projectsUrl = `${environment?.serverURL}/projects`;
  reportsUrl = `${environment?.reportsBaseURL}`;

  constructor(private http: HttpClient) {}

  getProjects(metaData: ProjectMetaData): Observable<any> {
    const {
      location,
      filter: {
        filterRange: { category, startDate, endDate }
      },
      sort: { sortBy, sortOrder },
      page,
      limit
    } = metaData;
    const params = pickBy({ location, category, sortBy, sortOrder, startDate, endDate, page, limit });
    const checkProps: boolean = Object.values(params)?.length === 8;

    if (checkProps)
      return this.http.get('projects', { params }).pipe(
        map((data: any) => data),
        catchError(() => of('Error, could not load projects'))
      );
  }

  getProjectIdsToHighlight(metaData: ProjectMetaData): Observable<string[]> {
    const {
      location,
      filter: {
        hTerms,
        filterRange: { category, startDate, endDate }
      },
      sort: { sortBy, sortOrder },
      search: { hSearchIn, hKeywords },
      savedSearch,
      hAddedDate
    } = metaData;

    const params = pickBy({
      location,
      category,
      sortBy,
      sortOrder,
      startDate,
      endDate,
      hSearchIn,
      hKeywords,
      savedSearch,
      hTerms,
      hAddedDate
    });

    const checkProps: boolean = Object.values(params)?.length >= 7;
    if (checkProps)
      return this.http
        .get<string[]>('projects/highlights', { params })
        .pipe(
          map((data: any[]) => data?.['Data']),
          catchError(() => of('Error, could not get project ids'))
        );
  }

  getReports(payload: any): Observable<any> {
    const { type, format, Ids } = payload;
    const httpOptions = {
      responseType: 'blob' as 'json'
    };
    return this.http.post(`${this.reportsUrl}?type=${type}&format=${format}`, { Ids }, { ...httpOptions }).pipe(
      map((data: any) => data),
      catchError(error => of(error))
    );
  }
}
